import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PartnerContactEntity } from "./partner-contact-entity";
import { Partner } from '../master-data/partner-entity';


export class PartnerSite extends BaseEntity {
  
    partner             : Partner = new Partner();
    partnerSiteCode     : string;
    name                : string; // site name;
    branchCode          : string;
    
    city                : string;
    siteCategoryCode    : string;
    siteCategoryTypeCode: string;
    geoAreaCode         : string;
    latitude            : number;
    longitude           : number;

    distanceToBranch    : number;
    timeToBranch        : number;

  //  assets              : AssetEntity[];
    partnerContacts     : PartnerContactEntity[];

}